<template>
  <wo-alert v-if="value" mod-error>{{ errorMessage }}</wo-alert>
</template>

<script>

import _ from 'lodash'

const DEFAULT_ERROR_KEY = 'error.general'

export default {
  name: 'PoErrorDisplay',
  props: {
    value: undefined,
    modScroll: Boolean
  },
  computed: {
    errorMessage () {
      const message = _.get(this.value, 'response.data.message')
      return message || this.$t(DEFAULT_ERROR_KEY)
    }
  },
  watch: {
    value () {
      if (this.modScroll && window.scrollTo) {
        window.scrollTo(0, 0)
      }
    }
  }
}
</script>
